import React from 'react';
import { ExclamationCircleIcon, ArrowPathIcon } from '@heroicons/react/24/outline';

interface ErrorStateProps {
  message: string;
  onRetry?: () => void;
  className?: string;
  compact?: boolean;
}

export const ErrorState: React.FC<ErrorStateProps> = ({ message, onRetry, className = '', compact = false }) => (
  compact ? (
    <div className={`flex items-center gap-2 px-4 py-3 rounded-lg bg-red-50 border border-red-200 text-sm text-red-700 ${className}`}>
      <ExclamationCircleIcon className="w-4 h-4 shrink-0" />
      <span className="flex-1 font-medium">{message}</span>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="ml-2 flex items-center gap-1 text-xs font-bold text-red-600 hover:text-red-800"
        >
          <ArrowPathIcon className="w-3 h-3" />
          Retry
        </button>
      )}
    </div>
  ) : (
    <div className={`flex flex-col items-center justify-center py-16 gap-5 text-center ${className}`}>
      <div className="w-14 h-14 rounded-lg bg-red-50 flex items-center justify-center">
        <ExclamationCircleIcon className="w-7 h-7 text-red-500" />
      </div>
      <div>
        <p className="text-sm font-bold text-slate-900 mb-1">Something went wrong</p>
        <p className="text-sm text-slate-500 max-w-xs">{message}</p>
      </div>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="flex items-center gap-2 px-4 py-2 rounded-lg border border-slate-200 bg-white text-sm font-bold text-slate-700 hover:bg-slate-50 transition-colors"
        >
          <ArrowPathIcon className="w-4 h-4" />
          Try again
        </button>
      )}
    </div>
  )
);

export default ErrorState;
